import { AnimatePresence } from 'framer-motion'

import { useManagementGetProducts } from '@apps-common/apis/management/product'
import { ProductCardSkeleton, ProductListCard } from '@apps-common/apps/portal/pages/management/components/product'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'

interface IProps {
  searchVal: string
}

export const ProductInfiniteView: React.FC<IProps> = ({ searchVal }) => {
  const { isLoading, isError, data, isRefetching, refetch } = useManagementGetProducts({
    name: searchVal
  })

  const loading = isLoading || isRefetching || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[60px]'>
        <PullRefresh loading={isRefetching} callback={() => refetch()} />
        <AnimatePresence>
          <div className='flex flex-col gap-4'>
            {loading && Array.from(Array(20).keys()).map((n, i) => <ProductCardSkeleton key={`product-card-skeleton-${i}`} />)}
            {!loading && data?.map((p) => <ProductListCard key={`product-list-${p.productId}`} product={p} />)}
            {!loading && data && data.length === 0 && <NoResultsCard>No product results.</NoResultsCard>}
          </div>
        </AnimatePresence>
      </LayoutPadding>
    </LayoutContainer>
  )
}
